import { Injectable } from '@angular/core';
import { comparators } from '../../core/comparators';
import { LabTestResultGridRowItem } from '../grid-row-item';
import { StandardTestResultsItem } from './standard-test-results.component';
import { split } from 'lodash';

export interface StandardTestResultSortableRow {
    sortableName: string;
    toString: () => string;
}

@Injectable()
export class StandardTestResultsSort {

    constructor() { }

    public getVisitName(x: LabTestResultGridRowItem | StandardTestResultsItem): string {
        return this.getEntityInfo(x, x.data.visitName);
    }

    public getComments(x: LabTestResultGridRowItem): string {
        return this.getEntityInfo(x, x.data.comments);
    }

    public sortEntities(a: string, b: string) {
        const separator = ':';
        const splitA = split(a, separator);
        const splitB = split(b, separator);

        let result = comparators.stringComparator(splitA[0] ? splitA[0].trim() : null, splitB[0] ? splitB[0].trim() : null);
        if (result === 0) {
            result = comparators.numberComparator(splitA[1] ? parseInt(splitA[1].trim(), 10) : null, splitB[1] ? parseInt(splitB[1].trim(), 10) : null);
        }

        return result;
    }

    private getEntityInfo(x: LabTestResultGridRowItem | StandardTestResultsItem, entityValue: string): string {
        const entityInfo: string[] = [];
        entityInfo.push(entityValue);
        entityInfo.push(` : ${x.data.exportSortId}`);

        return entityInfo.join(' ');
    }
}